import axios from "axios";

const fetch = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/api/v1/user-role/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const create = ({ name, enabled }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/account/api/v1/user-role`, { name, enabled })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const update = ({ id, name, enabled }) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/account/api/v1/user-role/${id}`, { name, enabled })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const userRole = {
  fetch,
  create,
  update,
};

export default userRole;
